import { Component, Inject, AfterViewInit } from "@angular/core";
import { MatOptionSelectionChange } from "@angular/material/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { GraphQLError } from "graphql";
import { AssignProjectLetterTemplateGQL, GetESignLetterTemplateToAssignGQL } from "../../../../generated/graphql";
import { SnackBarService } from "../../service/snack.bar.service";

@Component({
  selector: 'app-letter-dialog',
  templateUrl: './letter-dialog.component.html',
  styleUrls: ['./letter-dialog.component.css']
})
export class LetterDialogComponent implements AfterViewInit{
  letterTemplates: any[];
  letterTemplateIds: string[] = [];

  constructor(
    public dialogRef: MatDialogRef<LetterDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any,
    private snackbarService: SnackBarService,
    private getESignLetterTemplateToAssignGQL: GetESignLetterTemplateToAssignGQL,
    private assignProjectLetterTemplateGQL: AssignProjectLetterTemplateGQL,
  ){
    this.getESignLetterTemplateToAssignGQL.fetch({
      standardLetterId: this.data.standardLetterId,
      projectId: this.data.projectId
    }).subscribe(result =>{
      if(result.errors){
        this.snackbarService.showQueryError(result.errors);
        return;
      }
      this.letterTemplates = result.data.getESignLetterTemplateToAssign;
    })
  }

  selectedLetterTemplate(event: MatOptionSelectionChange) {
    if (event.source.selected) {
      this.letterTemplateIds.push(event.source.value);
    } else {
      this.letterTemplateIds = this.letterTemplateIds.filter(x => x != event.source.value);
    }
  }

  assign(){
    if(this.letterTemplateIds.length > 0){
      this.assignProjectLetterTemplateGQL.mutate({
        letterTemplateIds: this.letterTemplateIds,
        projectId: this.data.projectId,
        standardLetterId: this.data.standardLetterId
      }).subscribe((result)=>{
        if (result.data.assignProjectLetterTemplate) {
          this.snackbarService.show("Assigned successfully.");
          this.dialogRef.close(true);
        }
      }, (e: GraphQLError) => {
        this.snackbarService.showMutationError(e);
      })
    }
  }

  ngAfterViewInit(){

  }
}
